class coments {
  constructor(comentId, codApply, coment, cat, ws) {
    this.comentId = comentId;
    this.codApply = codApply;
    this.coment = coment;
    this.cat = cat;
    this.ws = ws;
  }
  static fromJson({ comentId, codAplica, comentario, cat, ws }) {
    return new coments(comentId, codAplica, comentario, cat, ws);
  }
}
export default coments;
